
/**
 * 트윗 유형
 */
export type TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType[keyof typeof TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendListResponsePageAllOfThreeContentItemContentTweetsItemReferencedTweetTweetBasicInfoAllOfTwoTweetType = {
  ORIGINAL: 'ORIGINAL',
  REPLY: 'REPLY',
  QUOTE: 'QUOTE',
  RETWEET: 'RETWEET',
} as const;
